import { useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import cards from '~/assets/icons/cards.svg';
import cash from '~/assets/icons/cash.svg';
import compass from '~/assets/icons/compass.svg';
import deposit from '~/assets/icons/deposit.svg';
import exchange from '~/assets/icons/exchange.svg';
import home from '~/assets/icons/home.svg';
import plus from '~/assets/icons/plus.svg';
import transfer from '~/assets/icons/transfer.svg';
import { ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { ShopBalance } from '~/components/ui/ShopBalance';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';
import { WalletType } from '~/shared';
import { useLayoutSelector } from '../../redux';
import {
	StyledContainer,
	StyledCreateDepositButtonContainer,
	StyledImg,
	StyledLeftContainer,
	StyledPopup,
	StyledRightContainer,
	StyledTextLabel,
} from './Head.styled';

const titleList: {
	title: string;
	icon: string;
}[] = [
	{
		title: 'Главная',
		icon: compass,
	},
	{
		title: 'Пополнение счёта',
		icon: deposit,
	},
	{
		title: 'Снятие наличных',
		icon: cash,
	},
	{
		title: 'Перевод средств',
		icon: transfer,
	},
	{
		title: 'Оплата налогов',
		icon: home,
	},
	{
		title: 'Обмен валют',
		icon: exchange,
	},
	{
		title: 'Мои карты',
		icon: cards,
	},
];

const Head: React.FC = () => {
	const [popupVisible, setPopupVisible] = useState<boolean>(false);

	const selectedIndex = useLayoutSelector(
		(state) => state.menuSelection.selectedIndex,
	);

	return (
		<StyledContainer>
			<StyledLeftContainer>
				<SwitchTransition>
					<CSSTransition
						timeout={300}
						classNames={'menu'}
						key={selectedIndex}
						addEndListener={(node, done) =>
							node.addEventListener('transitionend', done, false)
						}
					>
						<StyledImg
							src={titleList[selectedIndex].icon}
							width={20}
							height={20}
						/>
					</CSSTransition>
				</SwitchTransition>
				<SwitchTransition>
					<CSSTransition
						timeout={300}
						classNames={'menu'}
						key={selectedIndex}
						addEndListener={(node, done) =>
							node.addEventListener('transitionend', done, false)
						}
					>
						<StyledTextLabel>{titleList[selectedIndex].title}</StyledTextLabel>
					</CSSTransition>
				</SwitchTransition>
			</StyledLeftContainer>
			<StyledRightContainer>
				<StyledCreateDepositButtonContainer
					onMouseEnter={() => {
						setPopupVisible(true);
					}}
					onMouseLeave={() => setPopupVisible(false)}
				>
					<img
						src={plus}
						width={10}
						height={10}
						style={{ opacity: 0.25, pointerEvents: 'none' }}
					/>
					<Text
						style={{
							fontSize: '16px',
							fontWeight: 400,
							color: '#FFFFFF',
							opacity: 0.25,
							cursor: 'pointer',
						}}
					>
						Создать вклад
					</Text>
				</StyledCreateDepositButtonContainer>
				<CSSTransition
					in={popupVisible}
					classNames={'popup'}
					timeout={500}
					unmountOnExit
				>
					<StyledPopup text={'Создание вклада недоступно'} />
				</CSSTransition>
				<ShopBalance walletTypes={[WalletType.Cash]} transparent />
				<CloseButton
					color={ButtonColors.Default}
					height={ButtonHeight.Height40}
					iconSize={14}
					onClick={() => rage.bank.close()}
				/>
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { Head };
